import React, { useCallback } from 'react'
import { Button, Form, Input, message, Space, Typography } from 'antd'
import { useIntl } from 'react-intl'
import { useSingleLogin } from 'utils/queries'
import { useDispatch } from 'react-redux'
import { afterLoginHandler } from 'redux/user/actions'
import ResendOTP from './ResendOTP'

const { Text } = Typography

const VerificationOTPForm = ({ email, onBack, onResend, isOnModal = false }) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const singleLoginMutation = useSingleLogin()

  const handleSubmit = useCallback(
    (values) => {
      singleLoginMutation.mutate(
        { password: values.password, email, is_otp: 1 },
        {
          onSuccess: (response) => {
            if (response.data.success) {
              dispatch(afterLoginHandler(response, { email }))
              if (isOnModal) {
                window.location.reload(true)
              }
            } else {
              message.error(response.data?.message || 'Failed to verify code')
            }
          },
          onError: (e) => {
            message.error(e?.message || e?.data?.message)
          },
        },
      )
    },
    [dispatch, email, isOnModal, singleLoginMutation],
  )

  return (
    <Form layout="vertical" onFinish={handleSubmit} style={{ marginTop: 30 }}>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: formatMessage({
              id: 'please_input_the_verification_code',
            }),
          },
        ]}
      >
        <Input.OTP
          inputType="text"
          length={6}
          autoFocus
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '16px',
            width: 300,
            margin: '0 auto',
          }}
          formatter={(str) => str.toUpperCase()}
        />
      </Form.Item>
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <Text>
          {formatMessage(
            {
              id: 'otp_has_been_sent_to_your_email',
            },
            { email },
          )}
        </Text>
      </div>
      <ResendOTP onResend={onResend} />
      <Space direction="vertical" style={{ marginTop: 30, width: '100%' }}>
        <Button
          block
          type="primary"
          htmlType="submit"
          loading={singleLoginMutation.isLoading}
          disabled={singleLoginMutation.isLoading}
        >
          {formatMessage({ id: 'enter_kledo' })}
        </Button>
        <Button block htmlType="button" onClick={onBack}>
          {formatMessage({ id: 'button.back' })}
        </Button>
      </Space>
    </Form>
  )
}

export default VerificationOTPForm
